import React, { useEffect, useState } from "react"
import { Navigate, useNavigate, useRoutes } from "react-router-dom"
import { Login } from "../pages"
import lazyLoad from "./lazyLoad"
export const routeData: Array<any> = [
  {
    path: "/",
    element: <Login></Login>,
    meta: {
      key: "login",
    },
  },
  {
    path: "/login",
    element: lazyLoad(React.lazy(() => import("../pages/Login/index"))),
    meta: {
      key: "login",
    },
  },
  {
    path: "/elevator/screen",
    element: lazyLoad(React.lazy(() => import("../pages/DataCharts/ElevatorScreen/index"))),
  },
  {
    path: "/video/surveillance",
    element: lazyLoad(React.lazy(() => import("../pages/Cockpit/VideoSurveillance/index"))),
    meta: {
      key: "videoSurveillance",
    },
  },
  {
    path: "/video/resource",
    element: lazyLoad(React.lazy(() => import("../pages/Cockpit/resourceRecycling/index"))),
    meta: {
      key: "videoResource",
    },
  },
  {
    path: "/dataV/elevator_network/:id",
    element: lazyLoad(React.lazy(() => import("../pages/BigDataScreen/elevatorNetwork"))),
    meta: {
      key: "videoSurveillance",
    },
  },
  {
    path: "*",
    element: lazyLoad(React.lazy(() => import("../pages/Error/index"))),
    meta: {
      key: "error",
    },
  },
  {
    path: "/",
    // redirect:'/entity'
    element: <Navigate to="/entity/transaction"></Navigate>,
    meta: {
      key: "redirect",
    },
  },
  // 数据统计
  {
    path: "/data",
    element: lazyLoad(
      React.lazy(() => import("@/components/MenuWrapper")),
      { title: "数据统计", code: "data" }
    ),
    children: [
      // 数据看版
      {
        path: "/data/chart",
        element: lazyLoad(React.lazy(() => import("@src/pages/DataCharts/Charts"))),
      },
      // 数据统计
      {
        path: "/data/statistics",
        element: lazyLoad(React.lazy(() => import("@src/pages/DataCharts/Statistics"))),
      },
      {
        path: "/data/large",
        element: lazyLoad(React.lazy(() => import("@src/pages/DataCharts/LargeScreen"))),
      },
      {
        path: "/data/subsidy-grant",
        element: lazyLoad(React.lazy(() => import("@src/pages/DataCharts/SubsidyGrant"))),
      },
      {
        path: "/data/subsidy-grant/:idCard",
        element: lazyLoad(React.lazy(() => import("@src/pages/DataCharts/SubsidyGrant/Detail"))),
      },
    ],
  },
  // 店铺详情
  {
    path: "/agencyBusiness/storeDetail/:id",
    element: lazyLoad(React.lazy(() => import("../pages/BusinessAgent/StoreDetail/index"))),
  },
  // 实体交易
  {
    path: "/entity/transaction",
    element: lazyLoad(
      React.lazy(() => import("@/components/MenuWrapper")),
      { title: "交易中心", code: "entity" }
    ),
    children: [
      // 采购订单
      {
        path: "/entity/transaction/procureOrder",
        element: lazyLoad(React.lazy(() => import("@/pages/Entity/orderManagement/ProcureOrder"))),
      },
      {
        path: "/entity/transaction/procureOrder/:id",
        element: lazyLoad(
          React.lazy(() => import("@src/pages/Entity/orderManagement/ProcureOrder/detail"))
        ),
      },
      {
        path: "/entity/transaction/differenceOrder",
        element: lazyLoad(
          React.lazy(() => import("@/pages/Entity/orderManagement/differenceOrder"))
        ),
      },
      {
        path: "/entity/transaction/differenceOrder/:id",
        element: lazyLoad(
          React.lazy(() => import("@/pages/Entity/orderManagement/differenceOrder/detail"))
        ),
      },
      {
        path: "/entity/transaction/invoice",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/Invoice"))),
        meta: {
          key: "system_invoice",
        },
      },
      // 优惠券发放
      {
        path: "/entity/transaction/coupon",
        element: lazyLoad(React.lazy(() => import("@/pages/Entity/coupon/index"))),
      },
      // 积分商城管理
      {
        path: "/entity/transaction/pointsMall",
        element: lazyLoad(React.lazy(() => import("@/pages/Entity/pointsMall/index"))),
      },
      // 积分商城管理-新增商品
      {
        path: "/entity/transaction/pointsMall/create",
        element: lazyLoad(React.lazy(() => import("@/pages/Entity/pointsMall/Edit/index"))),
      },
      // 积分商城管理-编辑商品
      {
        path: "/entity/transaction/pointsMall/edit/:id",
        element: lazyLoad(React.lazy(() => import("@/pages/Entity/pointsMall/Edit/index"))),
      },
      // 资金流水
      {
        path: "/entity/transaction/records",
        element: lazyLoad(React.lazy(() => import("@/pages/Entity/Transaction/Records/index"))),
      },
      // 预付款台账
      {
        path: "/entity/transaction/depositBalances",
        element: lazyLoad(
          React.lazy(() => import("@/pages/Entity/Transaction/DepositBalances/list/index"))
        ),
      },
      {
        path: "/entity/transaction/depositBalances/detail",
        element: lazyLoad(
          React.lazy(() => import("@/pages/Entity/Transaction/DepositBalances/detail/index"))
        ),
      },
      // 客商查询
      {
        path: "/entity/transaction/merchant",
        element: lazyLoad(React.lazy(() => import("@/pages/Entity/merchant/index"))),
      },
      // 收购报废产品台账
      {
        path: "/entity/transaction/purchaseAndScrap",
        element: lazyLoad(React.lazy(() => import("@/pages/Entity/purchaseAndScrap/list"))),
      },
      // 订单应付台账
      {
        path: "/entity/transaction/orderPayableLedger",
        element: lazyLoad(React.lazy(() => import("@/pages/Entity/orderPayableLedger/list/index"))),
      },
      // 交易方案
      {
        path: "/entity/transaction/tradingScheme",
        element: lazyLoad(React.lazy(() => import("@src/pages/Entity/TradingScheme/index"))),
      },
      // 交易方案新建
      {
        path: "/entity/transaction/TradingSchemeDetail/:id",
        element: lazyLoad(
          React.lazy(() => import("@src/pages/Entity/TradingScheme/NewTradingScheme/index"))
        ),
      },
      // 交易方案详情
      {
        path: "/entity/transaction/tradingScheme/:id",
        element: lazyLoad(
          React.lazy(() => import("@src/pages/Entity/TradingScheme/Details/index"))
        ),
      },
    ],
  },
  {
    path: "/platformSetup",
    element: lazyLoad(
      React.lazy(() => import("@/components/MenuWrapper")),
      { title: "平台设置", code: "platformSetup" }
    ),
    children: [
      {
        path: "/platformSetup/user",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/User/index"))),
        meta: {
          key: "system_user",
        },
      },
      {
        path: "/platformSetup/Check",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/Check"))),
        meta: {
          key: "system_check",
        },
      },
      {
        path: "/platformSetup/Check/detail/:id",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/CheckDetail"))),
        meta: {
          key: "system_check_detail",
        },
      },
      {
        path: "/platformSetup/paymentActivation",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/PaymentActivation"))),
        meta: {
          key: "system_payment_activation",
        },
      },
      {
        path: "/platformSetup/inviteConfig",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/InviteConfig"))),
        meta: {
          key: "system_inviteConfig",
        },
      },
      {
        path: "/platformSetup/content",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/Content"))),
        meta: {
          key: "system_content",
        },
      },
      {
        path: "/platformSetup/content/create",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/Content/Create"))),
        meta: {
          key: "system_content_create",
        },
      },
      {
        path: "/platformSetup/content/edit/:id",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/Content/Create"))),
        meta: {
          key: "system_content_edit",
        },
      },
      {
        path: "/platformSetup/content/detail/:id",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/Content/Detail"))),
        meta: {
          key: "system_content_detail",
        },
      },
      {
        path: "/platformSetup/priceIndexConfig",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/PriceIndexConfig"))),
        meta: {
          key: "system_priceIndexConfig",
        },
      },
      {
        path: "/platformSetup/pvGuidePrice",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/PvGuidePrice"))),
        meta: {
          key: "system_pvGuidePrice",
        },
      },
      {
        path: "/platformSetup/PublicAccount/TwoCode",
        element: lazyLoad(
          React.lazy(() => import("@src/pages/PlatformSetup/PublicAccount/TwoCode"))
        ),
        meta: {
          key: "system_twoCode",
        },
      },
      {
        path: "/platformSetup/user/:id",
        element: lazyLoad(
          React.lazy(() => import("@src/pages/PlatformSetup/User/UserModal/Detail"))
        ),
      },
      {
        path: "/platformSetup/apply",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/Apply"))),
        meta: {
          key: "system_apply",
        },
      },
      {
        path: "/platformSetup/apply/:id/:type",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/Apply/Detail"))),
      },
      {
        path: "/platformSetup/tissue",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/Tissue"))),
        meta: {
          key: "system_tissue",
        },
      },
      {
        path: "/platformSetup/tissue/create/:applyNo",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/Tissue/create"))),
        meta: {
          key: "system_tissue",
        },
      },
      {
        path: "/platformSetup/tissue/info/:id",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/Tissue/info"))),
        meta: {
          key: "system_tissue",
        },
      },
      {
        path: "/platformSetup/district",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/TaxDistrict"))),
        meta: {
          key: "system_tissue",
        },
      },
      {
        path: "/platformSetup/district/create/:id",
        element: lazyLoad(
          React.lazy(() => import("@src/pages/PlatformSetup/TaxDistrict/NewTaxDistrict"))
        ),
        meta: {
          key: "system_tissue",
        },
      },
      {
        path: "/platformSetup/district/:id",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/TaxDistrict/Details"))),
        meta: {
          key: "system_tissue",
        },
      },
      // 合同模板管理
      {
        path: "/platformSetup/contractTemplate",
        element: lazyLoad(React.lazy(() => import("@src/pages/Entity/contractTemplate/index"))),
      },
      // 合同模板管理新建
      {
        path: "/platformSetup/contractTemplate/:type",
        element: lazyLoad(React.lazy(() => import("@src/pages/Entity/contractTemplate/create"))),
      },
      // 合同模板管理编辑
      {
        path: "/platformSetup/contractTemplate/:type/:id",
        element: lazyLoad(React.lazy(() => import("@src/pages/Entity/contractTemplate/create"))),
      },
      // 合同模板管理详情
      {
        path: "/platformSetup/contractTemplate/detail/:id",
        element: lazyLoad(React.lazy(() => import("@src/pages/Entity/contractTemplate/detail"))),
      },
      {
        path: "/platformSetup/utilOrder",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/UtilOrder"))),
        meta: {
          key: "system_utilOrder",
        },
      },
      {
        path: "/platformSetup/paySet",
        element: lazyLoad(React.lazy(() => import("@src/pages/PlatformSetup/PaySet"))),
        meta: {
          key: "system_paySet",
        },
      },
      {
        path: "/platformSetup/account/:id",
        element: lazyLoad(
          React.lazy(
            () => import("../pages/PlatformSetup/Tissue/components/financial/openAccount/jzb/index")
          )
        ),
      },
      {
        path: "/platformSetup/personalManagement/userManage",
        element: lazyLoad(
          React.lazy(() => import("../pages/PlatformSetup/PersonalManagement/UserManage"))
        ),
        meta: {
          key: "op_system_userManage",
        },
      },
      {
        path: "/platformSetup/personalManagement/role",
        element: lazyLoad(
          React.lazy(() => import("@src/pages/PlatformSetup/PersonalManagement/Role/index"))
        ),
        meta: {
          key: "op_system_role_list",
        },
      },
      // 平台品类
      {
        path: "/platformSetup/productTemplate",
        element: lazyLoad(React.lazy(() => import("@/pages/Entity/platformClassification"))),
      },
      {
        path: "/platformSetup/productTemplate/categoryParams",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/ProductCategoryParams/list"))),
      },
      // 电池资产
      {
        path: "/platformSetup/productTemplate/batteryAssets",
        element: lazyLoad(React.lazy(() => import("@/pages/PlatformSetup/batteryAssets"))),
        meta: {
          key: "op_platform_battery_assets",
        },
      },
      // 产品模型
      {
        path: "/platformSetup/productTemplate/productModal",
        element: lazyLoad(
          React.lazy(() => import("@/pages/PlatformSetup/productTemplate/productModal"))
        ),
      },
      {
        path: "/platformSetup/productTemplate/productModal/detail/:id?",
        element: lazyLoad(
          React.lazy(() => import("@/pages/PlatformSetup/productTemplate/productModal/detail"))
        ),
      },
      // 省市区
      {
        path: "/platformSetup/city",
        element: lazyLoad(React.lazy(() => import("@/pages/Entity/CityManagement"))),
      },
      // 联行号
      {
        path: "/platformSetup/bank",
        element: lazyLoad(React.lazy(() => import("@/pages/Entity/Bank"))),
      },
      {
        path: "/platformSetup/approvalManagement",
        element: lazyLoad(React.lazy(() => import("@/pages/approvalManagement/MyApproval"))),
      },
      {
        path: "/platformSetup/approvalManagement/mineApproval/:id",
        element: lazyLoad(React.lazy(() => import("@/pages/approvalManagement/MyApproval/detail"))),
      },
      {
        path: "/platformSetup/approvalManagement/followApproval/:processInstanceId",
        element: lazyLoad(
          React.lazy(() => import("@/pages/approvalManagement/MyApproval/followApproval"))
        ),
      },
      {
        path: "/platformSetup/resourceWorkOrder",
        element: lazyLoad(React.lazy(() => import("@/pages/PlatformSetup/WorkOrder/List"))),
      },
    ],
  },
  // 供应链金融
  {
    path: "/finance",
    element: lazyLoad(
      React.lazy(() => import("@/components/MenuWrapper")),
      { title: "供应链金融", code: "finance" }
    ),
    children: [
      // 个体户开办
      {
        path: "/finance/order",
        element: lazyLoad(React.lazy(() => import("../pages/SupplyFinance/financingOrder/index"))),
      },
      {
        path: "/finance/order/:id",
        element: lazyLoad(
          React.lazy(() => import("../pages/SupplyFinance/financingOrder/details/index"))
        ),
      },
      {
        path: "/finance/enterprise",
        element: lazyLoad(React.lazy(() => import("../pages/SupplyFinance/coreEnterprise/index"))),
      },
      {
        path: "/finance/enterprise/:id",
        element: lazyLoad(
          React.lazy(() => import("../pages/SupplyFinance/coreEnterprise/details/index"))
        ),
      },
      {
        path: "/finance/consent",
        element: lazyLoad(React.lazy(() => import("../pages/SupplyFinance/supplierAccess/index"))),
      },
      {
        path: "/finance/consent/:id",
        element: lazyLoad(
          React.lazy(() => import("../pages/SupplyFinance/supplierAccess/details/index"))
        ),
      },
      {
        path: "/finance/product",
        element: lazyLoad(
          React.lazy(() => import("../pages/SupplyFinance/financingProduct/index"))
        ),
      },
      {
        path: "/finance/product/:id",
        element: lazyLoad(
          React.lazy(() => import("../pages/SupplyFinance/financingProduct/details/index"))
        ),
      },
    ],
  },
  // 供应链运营
  {
    path: "/supplyChainOperation",
    element: lazyLoad(
      React.lazy(() => import("@/components/MenuWrapper")),
      { title: "供应链运营", code: "supplyChainOperation" }
    ),
    children: [
      {
        path: "/supplyChainOperation/organization",
        element: lazyLoad(
          React.lazy(
            () => import("@src/pages/SupplyChainOperation/supplyChainOperationOrganization")
          )
        ),
      },
      {
        path: "/supplyChainOperation/group",
        element: lazyLoad(
          React.lazy(() => import("@src/pages/SupplyChainOperation/supplyChainOperationGroup"))
        ),
      },
      {
        path: "/supplyChainOperation/mapResource",
        element: lazyLoad(React.lazy(() => import("@src/pages/SupplyChainOperation/mapResource"))),
      },
      {
        path: "/supplyChainOperation/changeApproval",
        element: lazyLoad(
          React.lazy(() => import("@src/pages/SupplyChainOperation/changeApproval"))
        ),
      },
      {
        path: "/supplyChainOperation/dataReport/template",
        element: lazyLoad(
          React.lazy(() => import("@src/pages/SupplyChainOperation/dataReport/TemplateManagement"))
        ),
      },
      {
        path: "/supplyChainOperation/dataReport/summary",
        element: lazyLoad(
          React.lazy(() => import("@src/pages/SupplyChainOperation/dataReport/SummarySharing"))
        ),
      },
    ],
  },
  // 业务代办
  {
    path: "/agencyBusiness",
    element: lazyLoad(
      React.lazy(() => import("@/components/MenuWrapper")),
      { title: "代办业务", code: "agencyBusiness" }
    ),
    children: [
      // 个体户开办
      {
        path: "/agencyBusiness/setup",
        element: lazyLoad(React.lazy(() => import("../pages/BusinessAgent/selfEmployed/index"))),
      },
      {
        path: "/agencyBusiness/setup/newApplication/:id",
        element: lazyLoad(
          React.lazy(() => import("../pages/BusinessAgent/selfEmployed/newApplication"))
        ),
      },
      {
        path: "/agencyBusiness/setup/:id",
        element: lazyLoad(
          React.lazy(() => import("../pages/BusinessAgent/selfEmployed/details/index"))
        ),
      },
      {
        path: "/agencyBusiness/ModifyInformation/:id",
        element: lazyLoad(
          React.lazy(
            () => import("../pages/BusinessAgent/selfEmployed/details/components/modifyInformation")
          )
        ),
      },
      {
        path: "/agencyBusiness/outSetup",
        element: lazyLoad(React.lazy(() => import("../pages/BusinessAgent/outSelfEmployed/index"))),
      },
      {
        path: "/agencyBusiness/outSetup/:id",
        element: lazyLoad(
          React.lazy(() => import("../pages/BusinessAgent/outSelfEmployed/details/index"))
        ),
      },
      {
        path: "/agencyBusiness/outNewLogout",
        element: lazyLoad(
          React.lazy(() => import("../pages/BusinessAgent/outSelfEmployed/newLogout/index"))
        ),
      },
      {
        path: "/agencyBusiness/deductions",
        element: lazyLoad(React.lazy(() => import("../pages/BusinessAgent/taxDeductions/index"))),
      },
      {
        path: "/agencyBusiness/surtax",
        element: lazyLoad(React.lazy(() => import("../pages/BusinessAgent/surtax/index"))),
      },
      {
        path: "/agencyBusiness/annual",
        element: lazyLoad(React.lazy(() => import("../pages/BusinessAgent/annualReport/index"))),
      },
      {
        path: "/agencyBusiness/taxPaid",
        element: lazyLoad(React.lazy(() => import("../pages/BusinessAgent/taxPaid/index"))),
      },
    ],
  },
  //开票系统
  {
    path: "/ticket",
    element: lazyLoad(
      React.lazy(() => import("@/components/MenuWrapper")),
      { title: "税票系统", code: "ticketOpenTask" }
    ),
    children: [
      {
        path: "/ticket/invoicingParty",
        element: lazyLoad(
          React.lazy(() => import("@src/pages/ReceiptSystem/pages/Ticket/InvoicingParty"))
        ),
      },
      {
        path: "/ticket/InvoicingTask",
        element: lazyLoad(React.lazy(() => import("../pages/ReceiptSystem/pages/InvoicingTask"))),
      },
      {
        path: "/ticket/InvoicingTask/info/:id",
        element: lazyLoad(
          React.lazy(() => import("../pages/ReceiptSystem/pages/InvoicingTask/InvoceInfo"))
        ),
      },
      {
        path: "/ticket/openTask",
        element: lazyLoad(
          React.lazy(() => import("@src/pages/ReceiptSystem/pages/openTask/openTask"))
        ),
      },
      {
        path: "/ticket/ledger",
        element: lazyLoad(React.lazy(() => import("@src/pages/ReceiptSystem/pages/ledger/ledger"))),
      },
      {
        path: "/ticket/regionCorrection",
        element: lazyLoad(
          React.lazy(() => import("@src/pages/ReceiptSystem/pages/RegionCorrection"))
        ),
      },
    ],
  },
  // 存证平台
  {
    path: "/evidence",
    element: lazyLoad(
      React.lazy(() => import("@/components/MenuWrapper")),
      { title: "存证平台", code: "evidence" }
    ),
    children: [
      // 模板列表
      {
        path: "/evidence/platform/template",
        element: lazyLoad(React.lazy(() => import("../pages/Evidence/pages/Template"))),
      },
      // 添加模版
      {
        path: "/evidence/platform/template/add",
        element: lazyLoad(
          React.lazy(() => import("../pages/Evidence/pages/Template/pages/AddTemplate"))
        ),
      },
      // 客户管理详情
      {
        path: "/evidence/platform/management/manage_info",
        element: lazyLoad(
          React.lazy(() => import("../pages/Evidence/pages/Management/pages/Info"))
        ),
        exact: true,
      },
      // 字段列表
      {
        path: "/evidence/platform/field",
        element: lazyLoad(React.lazy(() => import("../pages/Evidence/pages/Fields"))),
        meta: {
          key: "fields",
        },
      },
      // 字段模板创建和编辑
      {
        path: "/evidence/platform/field/add",
        element: lazyLoad(React.lazy(() => import("../pages/Evidence/pages/Fields/pages/Add"))),
      },
      // 存证场景关联字段信息
      {
        path: "/evidence/platform/field/list",
        element: lazyLoad(
          React.lazy(() => import("../pages/Evidence/pages/Fields/pages/FieldList"))
        ),
      },
      //   //客户关联存证
      {
        path: "/evidence/platform/add_evidence",
        element: lazyLoad(
          React.lazy(() => import("../pages/Evidence/pages/Management/pages/AddEvidence"))
        ),
      },
    ],
  },
  //物联管理
  {
    path: "/internet",
    element: lazyLoad(
      React.lazy(() => import("@/components/MenuWrapper")),
      { title: "物联管理", code: "internet" }
    ),
    children: [
      {
        path: "/internet",
        element: lazyLoad(React.lazy(() => import("@src/pages/Internet/supervisory/index"))),
      },
    ],
  },
  //物流管理
  {
    path: "/logistics",
    element: lazyLoad(
      React.lazy(() => import("@/components/MenuWrapper")),
      { title: "物流管理", code: "logistics" }
    ),
    children: [
      {
        path: "/logistics/warehouse",
        element: lazyLoad(React.lazy(() => import("../pages/logistics/warehouse/index"))),
      },
      {
        path: "/logistics/trajectory",
        element: lazyLoad(React.lazy(() => import("../pages/logistics/Trajectory/index"))),
      },
    ],
  },
  //运营中心
  {
    path: "/elevator",
    element: lazyLoad(
      React.lazy(() => import("@/components/MenuWrapper")),
      { title: "运营中心", code: "elevator" }
    ),
    children: [
      {
        path: "/elevator/management",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/ElevatorManagement"))),
      },
      {
        path: "/elevator/management/detail/:id",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/ElevatorManagement/details"))),
      },
      {
        path: "/elevator/dismantlingAllocation",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/DismantlingAllocation"))),
      },
      {
        path: "/elevator/dismantlingAllocation/add",
        element: lazyLoad(
          React.lazy(() => import("../pages/Elevator/DismantlingAllocation/newElevator"))
        ),
      },
      {
        path: "/elevator/dismantlingAllocation/edit/:id",
        element: lazyLoad(
          React.lazy(() => import("../pages/Elevator/DismantlingAllocation/newElevator"))
        ),
      },
      {
        path: "/elevator/dismantlingAllocation/detail/:id",
        element: lazyLoad(
          React.lazy(() => import("../pages/Elevator/DismantlingAllocation/details"))
        ),
      },
      {
        path: "/elevator/service",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/ServiceUnits"))),
      },
      {
        path: "/elevator/service/detail/:id",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/ServiceUnits/details"))),
      },
      {
        path: "/elevator/dismantlingUnits",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/DismantlingUnits"))),
      },
      {
        path: "/elevator/dismantlingUnits/detail/:id",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/DismantlingUnits/details"))),
      },
      {
        path: "/elevator/dismantlingUnits/scoreDetail/:id",
        element: lazyLoad(
          React.lazy(() => import("../pages/Elevator/DismantlingUnits/scoreDetail"))
        ),
      },
      {
        path: "/elevator/safety/riskControl",
        element: lazyLoad(
          React.lazy(() => import("../pages/Elevator/SafetyManagement/RiskControl"))
        ),
      },
      {
        path: "/elevator/safety/riskControl/create",
        element: lazyLoad(
          React.lazy(() => import("../pages/Elevator/SafetyManagement/RiskControl/Create"))
        ),
      },
      {
        path: "/elevator/safety/riskControl/edit/:id",
        element: lazyLoad(
          React.lazy(() => import("../pages/Elevator/SafetyManagement/RiskControl/Create"))
        ),
      },
      {
        path: "/elevator/safety/riskControl/detail/:id",
        element: lazyLoad(
          React.lazy(() => import("../pages/Elevator/SafetyManagement/RiskControl/Detail"))
        ),
      },
      {
        path: "/elevator/auditingUnits",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/AuditingUnits"))),
      },
      {
        path: "/elevator/auditingUnits/detail/:id",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/AuditingUnits/details"))),
      },
      {
        path: "/elevator/propertyUnits",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/PropertyUnits"))),
      },
      {
        path: "/elevator/propertyUnits/detail/:id",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/PropertyUnits/details"))),
      },
      {
        path: "/elevator/maintenanceUnits",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/MaintenanceUnits"))),
      },
      {
        path: "/elevator/maintenanceUnits/detail/:id",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/MaintenanceUnits/details"))),
      },
      {
        path: "/elevator/project",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/ProjectLibrary"))),
      },
      {
        path: "/elevator/project/add",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/ProjectLibrary/newElevator"))),
      },
      {
        path: "/elevator/project/detail/:id",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/ProjectLibrary/details"))),
      },
      {
        path: "/elevator/project/detail/:id/info/:recordId",
        element: lazyLoad(
          React.lazy(() => import("../pages/Elevator/ProjectLibrary/details/stepsDetails"))
        ),
      },
      {
        path: "/elevator/project/detail/:id/info/:recordId/material-disposal/track/:disposalId",
        element: lazyLoad(
          React.lazy(
            () =>
              import(
                "../pages/Elevator/ProjectLibrary/details/stepsDetails/materialDisposal/logisticsTrack"
              )
          )
        ),
      },
      {
        path: "/elevator/certificate/detail/:id",
        element: lazyLoad(
          React.lazy(
            () => import("../pages/Elevator/ProjectLibrary/details/stepsDetails/certificate")
          )
        ),
      },
      {
        path: "/elevator/property",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/PropertyManagement"))),
      },
      {
        path: "/elevator/property/detail/:id",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/PropertyManagement/details"))),
      },
      {
        path: "/elevator/finance",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/FinanceInsurance"))),
      },
      {
        path: "/elevator/finance/detail/:id",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/FinanceInsurance/details"))),
      },
      {
        path: "/elevator/department",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/GovernmentDepartment"))),
      },
      {
        path: "/elevator/department/detail/:id",
        element: lazyLoad(
          React.lazy(() => import("../pages/Elevator/GovernmentDepartment/details"))
        ),
      },
      {
        path: "/elevator/ladder",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/ElevatorOneFile"))),
      },
      {
        path: "/elevator/ladder/detail/:id",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/ElevatorOneFile/details"))),
      },
      {
        path: "/elevator/finance/billDetail",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/Finance/billDetail"))),
      },
      {
        path: "/elevator/vote/list",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/Vote/list"))),
      },
      {
        path: "/elevator/vote/management/:id",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/Vote/management"))),
      },
      {
        path: "/elevator/vote/InitiateVote",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/Vote/create"))),
      },
      {
        path: "/elevator/vote/InitiateVote/copy/:id",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/Vote/copy"))),
      },
      {
        path: "/elevator/contract",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/Contract"))),
      },
      {
        path: "/elevator/maintenance/plan",
        element: lazyLoad(
          React.lazy(() => import("../pages/Elevator/ElevatorMaintenance/Plan/List"))
        ),
      },
      {
        path: "/elevator/maintenance/work-order",
        element: lazyLoad(
          React.lazy(() => import("../pages/Elevator/ElevatorMaintenance/WorkOrder/List"))
        ),
      },
      {
        path: "/elevator/contract/create",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/Contract/Create"))),
      },
      {
        path: "/elevator/contract/edit/:id",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/Contract/Edit"))),
      },
      {
        path: "/elevator/contract/copy/:id",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/Contract/Copy"))),
      },
      {
        path: "/elevator/contract/detail/:id",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/Contract/Detail"))),
      },
      {
        path: "/elevator/complaint_hand",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/ComplaintHand"))),
      },

      {
        path: "/elevator/vote",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/ElevatorVote"))),
      },
      {
        path: "/elevator/lift/large",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/Large"))),
      },
      {
        path: "/elevator/data_statistics",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/DataStatistics"))),
      },
      {
        path: "/elevator/community",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/Community/index"))),
      },
      {
        path: "/elevator/community/:id",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/Community/details/index"))),
      },
      {
        path: "/elevator/equipment/list",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/Equipment/list"))),
      },
      {
        path: "/elevator/equipment/detail/:id",
        element: lazyLoad(React.lazy(() => import("../pages/Elevator/Equipment/detail"))),
      },
      {
        path: "/elevator/constructionPlan/planManagement",
        element: lazyLoad(
          React.lazy(() => import("@src/pages/PlatformSetup/ConstructionPlan/PlanManagement"))
        ),
        meta: {
          key: "system_construction_plan_management",
        },
      },
      {
        path: "/elevator/constructionPlan/markingScheme",
        element: lazyLoad(
          React.lazy(() => import("../pages/Elevator/ConstructionPlan/MarkingScheme/index"))
        ),
      },
      {
        path: "/elevator/constructionPlan/markingScheme/add",
        element: lazyLoad(
          React.lazy(() => import("../pages/Elevator/ConstructionPlan/MarkingScheme/add"))
        ),
      },
      {
        path: "/elevator/constructionPlan/markingScheme/edit/:id",
        element: lazyLoad(
          React.lazy(() => import("../pages/Elevator/ConstructionPlan/MarkingScheme/edit"))
        ),
      },
      {
        path: "/elevator/constructionPlan/markingScheme/detail/:id",
        element: lazyLoad(
          React.lazy(() => import("../pages/Elevator/ConstructionPlan/MarkingScheme/detail"))
        ),
      },
    ],
  },
]
const pageVipCheck = (p) => {
  const pages = ["agencyBusiness/storeDetail", "video/resource"]
  const arr = pages.map((item: string) => {
    return p.indexOf(item) > -1 ? true : false
  })

  return arr.includes(true)
}
const Element = () => {
  const loca = JSON.parse(localStorage.getItem("operation_authorization") || "{}")?.access_token_op
  const navigate = useNavigate()
  const routerInfo = location.href
  const [localRouteData, setRouteData] = useState(routeData)
  // 独立页面免登录
  useEffect(() => {
    if (!loca && !pageVipCheck(routerInfo)) {
      navigate("/login")
    }
  }, [loca])
  useEffect(() => {
    if (!loca && !pageVipCheck(routerInfo)) {
      const arr = [
        {
          path: "/login",
          element: <Login />,
          meta: {
            key: "login",
          },
        },
      ]
      setRouteData(arr)
    }
  }, [loca, routerInfo])
  return useRoutes(localRouteData)
}
export default Element
